import { render } from "./MediaSliderModal.vue?vue&type=template&id=dab8ace8&scoped=true"
import script from "./MediaSliderModal.vue?vue&type=script&lang=js"
export * from "./MediaSliderModal.vue?vue&type=script&lang=js"

import "./MediaSliderModal.vue?vue&type=style&index=0&id=dab8ace8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dab8ace8"]])

export default __exports__